import styled from 'styled-components/macro';

export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  flex: auto;
  margin: 0 auto;
  padding: 0 20px;
  max-width: ${(props) => props.theme.sizes[1]}px;
`;
